import { ProductTypeEnum } from "@jasper/client-models";

export default {
  [`${ProductTypeEnum.bridge}_one`]: "Bridge",
  [`${ProductTypeEnum.bridge}_other`]: "Bridges",
  [`${ProductTypeEnum.crown}_one`]: "Crown",
  [`${ProductTypeEnum.crown}_other`]: "Crowns",
  [`${ProductTypeEnum.splintedCrown}_one`]: "Splinted Crown",
  [`${ProductTypeEnum.splintedCrown}_other`]: "Splinted Crowns",
  [`${ProductTypeEnum.veneer}_one`]: "Veneer",
  [`${ProductTypeEnum.veneer}_other`]: "Veneers",
  [`${ProductTypeEnum.lay}_one`]: "Inlay/Onlay/Overlay",
  [`${ProductTypeEnum.lay}_other`]: "Inlay/Onlay/Overlay",
  [`${ProductTypeEnum.inlayCore}_one`]: "Inlay-core",
  [`${ProductTypeEnum.inlayCore}_other`]: "Inlay-cores",
  [`${ProductTypeEnum.waxBite}_one`]: "Wax bite",
  [`${ProductTypeEnum.waxBite}_other`]: "Wax bites",
  [`${ProductTypeEnum.retentionWire}_one`]: "Retention wire",
  [`${ProductTypeEnum.retentionWire}_other`]: "Retention wires",
  [`${ProductTypeEnum.orthoModel}_one`]: "Orthodontic study model",
  [`${ProductTypeEnum.orthoModel}_other`]: "Orthodontic study models",
  [`${ProductTypeEnum.dentureRepair}_one`]: "Removable denture repair",
  [`${ProductTypeEnum.dentureRepair}_other`]: "Removable denture repairs",
  [`${ProductTypeEnum.additionalImpressionForRemovableProsthesis}_one`]:
    "Additional impression for removable prosthesis",
  [`${ProductTypeEnum.additionalImpressionForRemovableProsthesis}_other`]:
    "Additional impressions for removable prosthesis",
  [`${ProductTypeEnum.implantCrown}_one`]: "Implant crown",
  [`${ProductTypeEnum.implantCrown}_other`]: "Implant crowns",
  [`${ProductTypeEnum.abutment}_one`]: "Abutment",
  [`${ProductTypeEnum.abutment}_other`]: "Abutments",
  [`${ProductTypeEnum.customAbutment}_one`]: "Custom abutment",
  [`${ProductTypeEnum.customAbutment}_other`]: "Custom abutments",
  [`${ProductTypeEnum.inlay}_one`]: "Inlay",
  [`${ProductTypeEnum.inlay}_other`]: "Inlay",
  [`${ProductTypeEnum.onlay}_one`]: "Onlay",
  [`${ProductTypeEnum.onlay}_other`]: "Onlay",
  [`${ProductTypeEnum.overlay}_one`]: "Overlay",
  [`${ProductTypeEnum.overlay}_other`]: "Overlay",
  [`${ProductTypeEnum.postAndCoreRetainedCrown}_one`]:
    "Post and core retained crown",
  [`${ProductTypeEnum.postAndCoreRetainedCrown}_other`]:
    "Post and core retained crowns",
  [`${ProductTypeEnum.implant}_one`]: "Implant",
  [`${ProductTypeEnum.implant}_other`]: "Implants",
  [`${ProductTypeEnum.splint}_one`]: "Splint",
  [`${ProductTypeEnum.splint}_other`]: "Splints",
  [`${ProductTypeEnum.nightGuard}_one`]: "Night guard",
  [`${ProductTypeEnum.nightGuard}_other`]: "Night guards",
  [`${ProductTypeEnum.bleachingTray}_one`]: "Bleaching tray",
  [`${ProductTypeEnum.bleachingTray}_other`]: "Bleaching trays",
  [`${ProductTypeEnum.retainer}_one`]: "Retainer",
  [`${ProductTypeEnum.retainer}_other`]: "Retainers",
  [`${ProductTypeEnum.removableDenture}_one`]: "Removable denture",
  [`${ProductTypeEnum.removableDenture}_other`]: "Removable dentures",
  [`${ProductTypeEnum.partialDenture}_one`]: "Partial denture",
  [`${ProductTypeEnum.partialDenture}_other`]: "Partial dentures",
  [`${ProductTypeEnum.fullDenture}_one`]: "Full denture",
  [`${ProductTypeEnum.fullDenture}_other`]: "Full dentures",
  [`${ProductTypeEnum.fullDentureWaxBite}_one`]: "Wax bite",
  [`${ProductTypeEnum.fullDentureWaxBite}_other`]: "Wax bites",
  [`${ProductTypeEnum.immediateDenture}_one`]: "Immediate denture",
  [`${ProductTypeEnum.immediateDenture}_other`]: "Immediate dentures",
  [`${ProductTypeEnum.model}_one`]: "Model",
  [`${ProductTypeEnum.model}_other`]: "Models",
  [`${ProductTypeEnum.richmondCrown}_one`]: "Richmond crown",
  [`${ProductTypeEnum.richmondCrown}_other`]: "Richmond crowns",
  [`${ProductTypeEnum.splintedCrownImplant}_one`]: "Splinted implant crown",
  [`${ProductTypeEnum.splintedCrownImplant}_other`]: "Splinted implant crowns",
  [`${ProductTypeEnum.bridgeImplant}_one`]: "Implant bridge",
  [`${ProductTypeEnum.bridgeImplant}_other`]: "Implant bridges",
  [`${ProductTypeEnum.bridgePontic}_one`]: "Pontic",
  [`${ProductTypeEnum.bridgePontic}_other`]: "Pontics",
  [`${ProductTypeEnum.scanOnly}_one`]: "Scan",
  [`${ProductTypeEnum.scanOnly}_other`]: "Scans",
  [`${ProductTypeEnum.spaceMaintainer}_one`]: "Space maintainer",
  [`${ProductTypeEnum.spaceMaintainer}_other`]: "Space maintainers",
  [`${ProductTypeEnum.waxUp}_one`]: "Wax Up",
  [`${ProductTypeEnum.waxUp}_other`]: "Wax Up",
  [`${ProductTypeEnum.addingTeethOnExistingDenture}_one`]:
    "Adding teeth on existing denture",
  [`${ProductTypeEnum.addingTeethOnExistingDenture}_other`]:
    "Adding teeth on existing dentures",
  [`${ProductTypeEnum.customTray}_one`]: "Custom tray",
  [`${ProductTypeEnum.customTray}_other`]: "Custom trays",
  [`${ProductTypeEnum.metalMesh}_one`]: "Metal mesh",
  [`${ProductTypeEnum.metalMesh}_other`]: "Metal meshes",
};
